(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[198],{

/***/ 38226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"block--26e2c","block-xs":"block-xs--6b8d5","blockXs":"block-xs--6b8d5","block-sm":"block-sm--809b6","blockSm":"block-sm--809b6","block-md":"block-md--699c6","blockMd":"block-md--699c6","block-lg":"block-lg--37db8","blockLg":"block-lg--37db8","block-xl":"block-xl--a9dd9","blockXl":"block-xl--a9dd9","disable-children-pointer-events":"disable-children-pointer-events--008ec","disableChildrenPointerEvents":"disable-children-pointer-events--008ec","varCtaHover":"var(--tkww-union-color-cta-hover, var(--tkww-union-color-primary-400, #D700A0))","varCtaDefault":"var(--tkww-union-color-cta-default, var(--tkww-union-color-primary-300, #FF44CB))","varCtaDisabled":"var(--tkww-union-color-cta-disabled, var(--tkww-union-color-primary-200, #FEBBF7))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varCtaDarkDefault":"var(--tkww-union-color-cta-dark-default, var(--tkww-union-color-neutral-black, #000))","varCtaDarkDefaultDisabled":"var(--tkww-union-color-cta-dark-default-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varCtaDarkDefaultHover":"var(--tkww-union-color-cta-dark-default-hover, var(--tkww-union-color-neutral-600, #37393F))","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","var-sp-base":"1rem","varSpBase":"1rem","var-sp-up-1":"1.25rem","varSpUp1":"1.25rem","animated-element":"animated-element--d7e20","animatedElement":"animated-element--d7e20","clicked":"clicked--927ab","btn-transitions":"btn-transitions--72b61","btnTransitions":"btn-transitions--72b61","cta-container":"cta-container--b8e2a","ctaContainer":"cta-container--b8e2a","icon":"icon--2f6f0","has-right-label":"has-right-label--e0af3","hasRightLabel":"has-right-label--e0af3","has-left-label":"has-left-label--81eda","hasLeftLabel":"has-left-label--81eda","loading-container":"loading-container--1cd9b cta-container--b8e2a","loadingContainer":"loading-container--1cd9b cta-container--b8e2a","loading-spinner":"loading-spinner--affe3","loadingSpinner":"loading-spinner--affe3","lg":"lg--6088e","md":"md--a5e6f","sm":"sm--6df06","btn":"btn--e1435 btn-transitions--72b61 disable-children-pointer-events--008ec buttonL--736ee","disabled":"disabled--be605","container":"container--5fa1f","primary":"primary--7aced","active":"active--311ff","primary-alternative":"primary-alternative--8dfe6","primaryAlternative":"primary-alternative--8dfe6","secondary":"secondary--2c01f","secondary-alternative":"secondary-alternative--fd0e3","secondaryAlternative":"secondary-alternative--fd0e3","tertiary":"tertiary--844aa","tertiary-alternative":"tertiary-alternative--026be","tertiaryAlternative":"tertiary-alternative--026be","quaternary":"quaternary--7aa06","quaternary-alternative":"quaternary-alternative--86dfc","quaternaryAlternative":"quaternary-alternative--86dfc"};

/***/ }),

/***/ 33500:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--1935d","icon-has-no-size":"icon-has-no-size--189a8","iconHasNoSize":"icon-has-no-size--189a8","size-sm":"size-sm--ad48b","sizeSm":"size-sm--ad48b","size-md":"size-md--ffa00","sizeMd":"size-md--ffa00","size-lg":"size-lg--2b900","sizeLg":"size-lg--2b900"};

/***/ }),

/***/ 54943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ AnimatedElement; },
/* harmony export */   "q": function() { return /* binding */ useAnimationProps; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79021);
/* harmony import */ var _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var _ThemeContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97367);




const ANIMATION_DURATION = 250;
const useAnimationProps = () => {
  const [clicked, setClicked] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
  const timerRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef();
  const onClick = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
    setClicked(true);
    clearTimeout(timerRef.current);
    timerRef.current = _babel_runtime_corejs3_core_js_set_timeout__WEBPACK_IMPORTED_MODULE_0___default()(() => {
      setClicked(false);
    }, ANIMATION_DURATION);
  }, []);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => () => {
    clearTimeout(timerRef.current);
  }, []);
  return {
    clicked,
    onClick
  };
};
const AnimatedElement = _ref => {
  let {
    classes: classesProp
  } = _ref;
  const classes = (0,_ThemeContext_js__WEBPACK_IMPORTED_MODULE_2__/* .useButtonClasses */ .B)(classesProp);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
    "aria-hidden": "true",
    className: classes['animated-element']
  });
};
 false ? 0 : void 0;

/***/ }),

/***/ 34925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _xo_union_ui_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9433);
/* harmony import */ var _Animation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54943);
/* harmony import */ var _CtaContainer_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50660);
/* harmony import */ var _LoadingContainer_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19954);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69955);










/**
 * Render native button with union styles
 *
 * ref is passed to underlying button
 */
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: Type,
    loadingText,
    ...ownProps
  } = _ref;
  const {
    isLoading
  } = ownProps;
  const finalProps = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useButtonProps */ .FT)(ownProps, false);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_xo_union_ui_accessibility__WEBPACK_IMPORTED_MODULE_2__/* .Focusable */ .Y, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    as: Type,
    ref: ref
  }, finalProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Animation_js__WEBPACK_IMPORTED_MODULE_4__/* .AnimatedElement */ .F, {
    classes: ownProps.classes
  }), isLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LoadingContainer_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    classes: ownProps.classes,
    loadingText: loadingText
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CtaContainer_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    classes: ownProps.classes
  }, ownProps)));
});
 false ? 0 : void 0;
Button.defaultProps = {
  as: 'button',
  size: 'lg',
  color: 'primary',
  isLoading: false,
  loadingText: 'Loading'
};
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 50660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CtaContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/node_modules/classnames/index.js
var classnames = __webpack_require__(71066);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/node_modules/@xo-union/tk-component-icons/lib/css/base.css
var base = __webpack_require__(33500);
var base_default = /*#__PURE__*/__webpack_require__.n(base);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/node_modules/@xo-union/tk-component-icons/lib/icon-sets/v2/index.js
/* harmony default export */ var v2 = ({
  resolve: iconName => ({
    id: `v2-icon-${iconName}`,
    className: ''
  })
});
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js






/**
 * Component used to render a non interactive icon based on the definitions in the loaded icons fragment
 */
const Icon = _ref => {
  let {
    name,
    iconSet,
    className,
    size,
    ...rest
  } = _ref;
  const {
    id,
    className: ownClassName
  } = iconSet.resolve(name);
  const classes = [(base_default()).icon, size ? (base_default())[`size-${size}`] : (base_default())["icon-has-no-size"], className, ownClassName];
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends["default"])({
    className: classes.join(' ')
  }, rest), /*#__PURE__*/react.createElement("use", {
    xlinkHref: `#${id}`
  }));
};
 false ? 0 : void 0;
Icon.defaultProps = {
  className: '',
  iconSet: v2,
  size: null
};
/* harmony default export */ var components_Icon = (Icon);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/ThemeContext.js
var ThemeContext = __webpack_require__(97367);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-component-buttons/lib/components/CtaContainer/index.js






const CtaContainer = _ref => {
  let {
    children,
    classes: classesProp,
    iconName,
    labelDirection,
    size
  } = _ref;
  const classes = (0,ThemeContext/* useButtonClasses */.B)(classesProp);
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()(classes['cta-container'], iconName && classes[`has-${labelDirection || 'left'}-label`])
  }, iconName && /*#__PURE__*/react.createElement(components_Icon, {
    name: iconName,
    className: classes.icon,
    size: size === 'lg' ? 'lg' : 'md',
    "aria-hidden": "true"
  }), children);
};
 false ? 0 : void 0;
/* harmony default export */ var components_CtaContainer = (CtaContainer);

/***/ }),

/***/ 60588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _xo_union_ui_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9433);
/* harmony import */ var _Animation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54943);
/* harmony import */ var _LoadingContainer_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19954);
/* harmony import */ var _CtaContainer_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50660);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69955);










/**
 * Render a native link with union button styles
 *
 * ref is passed to underlying link
 */
const Link = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: Type,
    loadingText,
    ...ownProps
  } = _ref;
  const {
    isLoading
  } = ownProps;
  const finalProps = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useLinkProps */ .eY)(ownProps, false);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_xo_union_ui_accessibility__WEBPACK_IMPORTED_MODULE_2__/* .Focusable */ .Y, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    as: Type,
    ref: ref
  }, finalProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Animation_js__WEBPACK_IMPORTED_MODULE_4__/* .AnimatedElement */ .F, {
    classes: ownProps.classes
  }), isLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LoadingContainer_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    classes: ownProps.classes,
    loadingText: loadingText
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CtaContainer_index_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    classes: ownProps.classes
  }, ownProps)));
});
 false ? 0 : void 0;
Link.defaultProps = {
  as: 'a',
  size: 'lg',
  color: 'primary',
  isLoading: false,
  loadingText: 'Loading'
};
Link.displayName = 'Link';
/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 19954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _xo_union_tk_component_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15771);
/* harmony import */ var _ThemeContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97367);





const LoadingContainer = _ref => {
  let {
    classes: classesProp,
    loadingText
  } = _ref;
  const classes = (0,_ThemeContext_js__WEBPACK_IMPORTED_MODULE_1__/* .useButtonClasses */ .B)(classesProp);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes['loading-container']
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_xo_union_tk_component_spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    className: classes['loading-spinner'],
    size: "sm"
  }), loadingText);
};
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (LoadingContainer);

/***/ }),

/***/ 97367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useButtonClasses; },
/* harmony export */   "f": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _xo_union_react_css_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33289);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38226);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_index_css__WEBPACK_IMPORTED_MODULE_1__);





const ClassesContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext((_css_index_css__WEBPACK_IMPORTED_MODULE_1___default()));
const ThemeProvider = _ref => {
  let {
    children,
    classes: classesProp
  } = _ref;
  const classes = (0,_xo_union_react_css_modules__WEBPACK_IMPORTED_MODULE_2__.useClasses)((_css_index_css__WEBPACK_IMPORTED_MODULE_1___default()), classesProp);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ClassesContext.Provider, {
    value: classes
  }, children);
};
 false ? 0 : void 0;
const useButtonClasses = override => {
  const contextClasses = react__WEBPACK_IMPORTED_MODULE_0__.useContext(ClassesContext);
  const ownClasses = (0,_xo_union_react_css_modules__WEBPACK_IMPORTED_MODULE_2__.useClasses)((_css_index_css__WEBPACK_IMPORTED_MODULE_1___default()), override);
  if (override !== undefined) {
    return ownClasses;
  }
  return contextClasses;
};

/***/ }),

/***/ 69955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; },
/* harmony export */   "eY": function() { return /* binding */ useLinkProps; },
/* harmony export */   "gj": function() { return /* binding */ getClassName; }
/* harmony export */ });
/* unused harmony export limitPropUsageToTertiaryButtons */
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28301);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71066);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_ThemeContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97367);
/* harmony import */ var _components_Animation_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54943);




const getClassName = (ownProps, animationProps, classes) => classnames__WEBPACK_IMPORTED_MODULE_1___default()(classes.btn, classes[ownProps.size], classes[ownProps.color], ownProps.className, ownProps.block === true && classes.block, `block-${ownProps.block}` in classes && classes[`block-${ownProps.block}`], ownProps.disabled && classes.disabled, ownProps.isLoading && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
const getContainerClassName = (ownProps, animationProps, classes) => classnames__WEBPACK_IMPORTED_MODULE_1___default()(classes.container, ownProps.className, ownProps.disabled && classes.disabled, ownProps.active && classes.active, animationProps.clicked && classes.clicked);
const mergeCallbacks = function () {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _babel_runtime_corejs3_core_js_instance_for_each__WEBPACK_IMPORTED_MODULE_0___default()(callbacks).call(callbacks, callback => {
      if (typeof callback === 'function') {
        callback(...args);
      }
    });
  };
};
const disabledProps = {
  tabIndex: '-1',
  role: 'button',
  'aria-disabled': 'true'
};
const disabledClickHandler = evt => {
  evt.preventDefault();
};
const handleLinkProps = (ownProps, animationProps, isContainer, linkStyles) => {
  const {
    active,
    block,
    classes,
    className,
    color,
    disabled,
    href,
    iconName,
    isLoading,
    labelDirection,
    onClick: ownOnClick,
    size,
    to,
    ...passThroughProps
  } = ownProps;
  const isDisabled = disabled || isLoading || !href && !to;
  const additionalProps = isDisabled ? disabledProps : {
    href,
    to
  };
  const onClick = isDisabled ? disabledClickHandler : mergeCallbacks(animationProps.onClick, ownOnClick);
  const classNameFunc = isContainer ? getContainerClassName : getClassName;
  return {
    ...passThroughProps,
    ...additionalProps,
    onClick,
    className: classNameFunc(ownProps, animationProps, linkStyles)
  };
};
const handleButtonProps = (ownProps, animationProps, isContainer, buttonStyles) => {
  const {
    active,
    block,
    classes,
    className,
    color,
    disabled,
    iconName,
    isLoading,
    labelDirection,
    onClick: ownOnClick,
    size,
    type,
    ...passThroughProps
  } = ownProps;
  const isDisabled = isLoading || disabled;
  const classNameFunc = isContainer ? getContainerClassName : getClassName;
  return {
    ...passThroughProps,
    'aria-disabled': isDisabled,
    className: classNameFunc(ownProps, animationProps, buttonStyles),
    disabled: isDisabled,
    onClick: mergeCallbacks(animationProps.onClick, ownOnClick),
    type
  };
};
const useButtonProps = (ownProps, isContainer) => {
  const animationProps = (0,_components_Animation_js__WEBPACK_IMPORTED_MODULE_2__/* .useAnimationProps */ .q)();
  const classes = (0,_components_ThemeContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useButtonClasses */ .B)(ownProps.classes);
  return handleButtonProps(ownProps, animationProps, isContainer, classes);
};
const useLinkProps = (ownProps, isContainer) => {
  const animationProps = (0,_components_Animation_js__WEBPACK_IMPORTED_MODULE_2__/* .useAnimationProps */ .q)();
  const classes = (0,_components_ThemeContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useButtonClasses */ .B)(ownProps.classes);
  return handleLinkProps(ownProps, animationProps, isContainer, classes);
};
const limitPropUsageToTertiaryButtons = propType => function (props, propName) {
  if (props[propName] && props.color !== 'tertiary') {
    return new Error(`The ${propName} prop is only available if the \`color\` prop is set to "tertiary".`);
  }
  for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    rest[_key3 - 2] = arguments[_key3];
  }
  return propType(props, propName, ...rest);
};

/***/ }),

/***/ 71066:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);